import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/anniversary2nd/img_card_people.png")